import callApi from "helpers/callApi";

export const FUND_REQUEST_CREATE_ENDPOINT = "/manager/billing_history/fund_request";
export const FUND_MANAGERS_ENDPOINT = "/manager/billing_history/fund_managers";

export function getFundRequestByIdEndpoint(fundRequestId) {
  return `/manager/billing_history/fund_request/${fundRequestId}`;
}

export const getFundRequestUpdateEndpoint = getFundRequestByIdEndpoint;
export const getFundRequestDeleteEndpoint = getFundRequestByIdEndpoint;

function parseFundRequestApiError(response) {
  throw new Error(response.errorMessage || "Error");
}

export async function fetchFundManagers(search) {
  const params = {};
  const query = String(search ?? "").trim();
  if (query) {
    params.search = query;
  }
  const response = await callApi(FUND_MANAGERS_ENDPOINT, "GET", params);
  if (!response.ok) {
    parseFundRequestApiError(response);
  }
  return response.json();
}

export async function createFundRequest(payload) {
  const response = await callApi(FUND_REQUEST_CREATE_ENDPOINT, "POST", payload);
  if (!response.ok) {
    parseFundRequestApiError(response);
  }
  return response.json();
}

export async function updateFundRequest(fundRequestId, payload) {
  const response = await callApi(getFundRequestUpdateEndpoint(fundRequestId), "PUT", payload);
  if (!response.ok) {
    parseFundRequestApiError(response);
  }
  return response.json();
}

export async function fetchFundRequestManagerDetail(fundRequestId) {
  const response = await callApi(getFundRequestByIdEndpoint(fundRequestId), "GET");
  if (!response.ok) {
    parseFundRequestApiError(response);
  }
  return response.json();
}

export async function deleteFundRequest(fundRequestId) {
  const response = await callApi(getFundRequestDeleteEndpoint(fundRequestId), "DELETE");
  if (!response.ok) {
    parseFundRequestApiError(response);
  }
  if (response.status === 204) {
    return null;
  }
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
}
